export default __webpack_public_path__ + "static/media/discovery-mass-icon.e5eaf0c6.svg";